import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "MaterialManagementService",
  controller: "MaterialStat",
};

const methods = [
   "GetMaterialStat",
   "GetMaterialUsageStat"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    Fun.prototype[path] = function(data) {
      return this.post(path, data);
    };
  });
};

const MaterialStatResourcesApi = ZJApi.defineNewApi("MaterialStatResourcesApi", factory);

export default MaterialStatResourcesApi;
